import api from './api';
import TokenService from './token.service';

const register = (username, email, password) => {
  return api.post('/auth/signup', {
    username,
    email,
    password,
  });
};

const login = (username, password, param1) => {
  return api
    .post('/auth/signin', {
      username,
      password,
      param1
    })
    .then((response) => {
      if (response.data.accessToken) {
        TokenService.setUser(response.data);
      }

      return response.data;
    });
};

const logout = () => {
  TokenService.removeUser();
  console.log('---auth.service.js---logout()---');
  api.post('/onelogin/logout');
};

const getCurrentUser = () => {
  return JSON.parse(localStorage.getItem('user'));
};

const AuthService = {
  register,
  login,
  logout,
  getCurrentUser,
};

export default AuthService;
